import React from "react";
import styled, { css } from "styled-components";

export default function PlayIcon({
  bg = "--white",
  iconBg = "--light-blue",
  hover = "",
  ...props
}) {
  return (
    <StyledPlayIcon $bg={bg} $iconBg={iconBg} $hover={hover} {...props}>
      <i className="icon icon-play"></i>
    </StyledPlayIcon>
  );
}

const StyledPlayIcon = styled.div`
  position: relative;
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    width: 36px;
    height: 36px;
    background-color: var(${({ $iconBg }) => $iconBg});
  }

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(${({ $bg }) => $bg});
    width: 90px;
    height: 90px;
    border-radius: 50%;
    transition: 0.4s ease;
    cursor: pointer;
  }

  &:hover {
    i {
      background-color: var(${({ $bg }) => $bg});
    }

    &::before {
      width: 105px;
      height: 105px;
      background-color: var(${({ $iconBg }) => $iconBg});
    }
  }

  ${({ $hover }) =>
    $hover === "static" &&
    css`
      &:hover {
        i {
          background-color: var(${({ $iconBg }) => $iconBg});
        }

        &::before {
          background-color: var(${({ $bg }) => $bg});
        }
      }
    `}
`;
